<template>
	<div style="text-align:center;">
		<el-row :gutter="10">
		<div class="tip" v-if="infoProfileAdvisor.cat_advisor_status_id==2 && infoProfileAdvisor.isCompleted==1">
			<p>
			¡En hora buena!, La solicitud paso a una etapa de validación de la información capturada, 
			En cuanto este proceso termine se le notificara vía correo electrónico.
			</p>
		</div>
		<div v-if="infoProfileAdvisor.cat_advisor_status_id!=3">
			<el-col :span="6">
				<el-card id="step1" 
					:body-style="{ padding: '0px' }" 
					:class="this.infoProfileAdvisor.step >= 1 ? 'bg-success text-white' : ''">
					<p>Paso 1</p>
					<i class="fas fa-user-edit"></i>
					<p>Edite y confirme sus datos generales</p>
				</el-card>
			</el-col>
			<el-col :span="6">
				<el-card id="step2" 
					:body-style="{ padding: '0px' }" 
					:class="this.infoProfileAdvisor.step >= 2 ? 'bg-success text-white' : ''">
					<p>Paso 2</p>
					<i class="fas fa-file-alt"></i>
					<p>Suba la documentación requerida</p>
				</el-card>
			</el-col>
			<el-col :span="6">
				<el-card id="step3" 
					:body-style="{ padding: '0px' }" 
					:class="this.infoProfileAdvisor.step >= 3 ? 'bg-success text-white' : ''">
					<p>Paso 3</p>
					<i class="fas fa-map-marked-alt"></i>
					<p>Complete y verifique la información de sus centros de trabajo</p>
				</el-card>
			</el-col>
			<el-col :span="6">
				<el-card id="step4" 
					:body-style="{ padding: '0px' }" 
					:class="this.infoProfileAdvisor.step >= 4 ? 'bg-success text-white' : ''">
					<p>Paso 4</p>
					<i class="fas fa-id-card-alt"></i>
					<p>Complete y verifique sus planes de capacitación</p>
				</el-card>
			</el-col>
		</div>	
		</el-row>
		<br/>
		<div v-if="infoProfileAdvisor.cat_advisor_status_id!=3">
		<el-row :gutter="10">
			<el-col :span="6">
				<el-card id="step5" 
					:body-style="{ padding: '0px' }" 
					:class="this.infoProfileAdvisor.step >= 5 ? 'bg-success text-white' : ''">
					<p>Finaliza tu proceso</p>
					<i class="far fa-thumbs-up"></i>
					<p>Descargue sus fichas</p>
				</el-card>
			</el-col>
		</el-row>
		</div>
		<div v-if="infoProfileAdvisor.cat_advisor_status_id==3">
				<Company></Company>
		</div>
	</div>
</template>

<script>
	import Company from "@/components/views/home/advisor/company/Index";

	import {completeAdvisorProfileMix} from '@/mixins/advisor/completeAdvisorProfile';


	export default {
		mixins: [completeAdvisorProfileMix],
		components: {Company},
		methods: {
			editData() {
				this.$router.push('/perfilTutores/paso1');
			},
			editDocuments() {
				if (this.infoProfileAdvisor.step >= 1) {
					this.$router.push('/perfilTutores/paso2');
				} else {
					this.$message({
              			type: "warning",
              			title: "Éxito",
              			message: "Aún debes completar un paso anterior"
            		});
				}
			},
			editPlaces() {
				if (this.infoProfileAdvisor.step >= 2) {
					this.$router.push('perfilTutores/centros-de-trabajo');
				} else {
					this.$message({
              			type: "warning",
              			title: "Éxito",
              			message: "Aún debes completar un paso anterior"
            		});
				}
			},
			editPlans() {
				if (this.infoProfileAdvisor.step >= 3) {
					this.$router.push('/perfilTutores/paso4');
				} else {
					this.$message({
              			type: "warning",
              			title: "Éxito",
              			message: "Aún debes completar un paso anterior"
            		});
				}
			},
			finish() {
				if (this.infoProfileAdvisor.step >= 4) {
					this.$router.push('/perfilTutores/paso5');
				} else {
					this.$message({
              			type: "warning",
              			title: "Éxito",
              			message: "Aún debes completar un paso anterior"
            		});
				}
			}
		},
		mounted() {
			document.getElementById('step1').addEventListener("click", this.editData);
			document.getElementById('step2').addEventListener("click", this.editDocuments);
			document.getElementById('step3').addEventListener("click", this.editPlaces);
			document.getElementById('step4').addEventListener("click", this.editPlans);
			document.getElementById('step5').addEventListener("click", this.finish);
		},
		data() {
			return {
				form : {
				}
			}
		},
		computed: {},
	}
</script>

<style scoped>
	.el-card {
		min-height: 150px;
		cursor: pointer;
	}
	.bg-success {
		background-color: #67C23A;
	}

	.text-white {
		color: white
	}

</style>